export default Object.freeze({
  UK: 'uk',
  ES: 'es',
  PT: 'pt',
  IT: 'it',
  FR: 'fr',
  CH: 'ch',
  US: 'us',
  CA: 'ca',
  GLOBAL: 'global',
});
